import { css } from 'styled-components';

export const menuItemRow = css`
  align-self: stretch;
  color: var(--color-black);
`;

export const menuActionRow = css`
  align-self: stretch;
  padding: 6px 8px;
  border-radius: 12px;
  color: #000;
  font-size: 14px;
  line-height: normal;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover:not(:disabled),
  &:focus-visible {
    background-color: var(--ln-menu-hover);
  }
`;
